if(!customElements.get('menu-drawer')) {
  customElements.define(
    'menu-drawer',
    class MenuDrawer extends HTMLElement {
      #trigger;
      #drawer;
      #onTriggerClick;
      #open;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#open = false;
        this.#trigger = this.querySelectorAll('[data-trigger]');

        if (!this.#trigger?.length) return;

        this.#onTriggerClick = this.onTriggerClick.bind(this);
        this.#trigger.forEach(t => {
          t.addEventListener('click', this.#onTriggerClick);
        });
      }

      disconnectedCallback() {
        this.#trigger?.forEach(t => {
          t.removeEventListener('click', this.#onTriggerClick);
        });
      }

      onTriggerClick() {
        this.#open = !this.#open;
        this.updateUI();
      }

      updateUI() {
        this.#trigger.forEach(t => t.classList.toggle('active', this.#open));
        window.dispatchEvent(
          new CustomEvent('update-drawer', {
            detail: { open: this.#open }
          })
        );
      }
    }
  );
}